import { GzExchangeAntimalwareOnDemandScanCredentialsFormWebComponent } from './component/GzExchangeAntimalwareOnDemandScanCredentialsFormWebComponent';

export { GzExchangeAntimalwareOnDemandScanCredentialsFormWebComponent };
